import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { enableMapSet } from 'immer';
import { carsSlice } from './slices/cars/cars.slice';
import { rentDetailsSlice } from './slices/rentDetails/rentDetails.slice';
import { ordersSlice } from './slices/orders/orders.slice';
import { usersSlice } from './slices/users/users.slice';
import { discountsSlice } from './slices/discounts/discounts.slice';
import { upcomingActionsSlice } from './slices/upcoming-actions/upcoming-actions.slice';
import { clientDashboardSlice } from './slices/client-dashboard/client-dashboard.slice';
import { generalSlice } from './slices/general/general.slice';
import { subscriptionsSlice } from './slices/subscriptions/subscriptions.slice';
enableMapSet();
export const store = configureStore({
  reducer: {
    [usersSlice.name]: usersSlice.reducer,
    [subscriptionsSlice.name]: subscriptionsSlice.reducer,
    [generalSlice.name]: generalSlice.reducer,
    [clientDashboardSlice.name]: clientDashboardSlice.reducer,
    [upcomingActionsSlice.name]: upcomingActionsSlice.reducer,
    [carsSlice.name]: carsSlice.reducer,
    [rentDetailsSlice.name]: rentDetailsSlice.reducer,
    [ordersSlice.name]: ordersSlice.reducer,
    [discountsSlice.name]: discountsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
